var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewsCenter',{attrs:{"rootId":_vm.NEWS_ROOT_ID,"columnTree":_vm.columnTree}})
}
var staticRenderFns = []

export { render, staticRenderFns }